import React from "react";
import { 
  Button, 
  Card, 
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import MetaData from "#root/layouts/MetaData";
import { ROUTES } from "#root/routes/constants";

const InternalServerError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaData
        title="500 Internal Server Error"
        description="Sorry, something went wrong on our end."
      />
      <Card appearance="filled-alternative">
        <Text size={900} weight="bold" align="center">500</Text>
        <Text size={500} align="center">Sorry, something went wrong on our end.</Text>
        <Button appearance="primary" onClick={() => navigate(ROUTES.ROOT)} style={{ display: 'block', margin: '0 auto' }}>
          Back Home
        </Button>
      </Card>
    </>
  );
};

export default InternalServerError;
